var exports = {
  "lZ": "CreateIssueDialogContainer__Zr6huN",
  "$Z": "dialogHidden__L1zQS2",
  "D1": "footerWithDuplicatesShown__D1NSX5",
};

module.exports = exports;
